import React from 'react';
import  './mathSkill.css'
import { AiFillGithub } from 'react-icons/ai';


const MathSkill = () => {
    return (
        <section className='mathSkill'>
            <div className='mathSkillLeft'>
            <div className='mathSkillDescription'>
                            <h3>Analytical skills</h3>
                            <div className='skillsWrapperMath'>
                                <div className="i-title-math">
                                    <div className="i-title-wrapper-math">
                                        <div className="i-title-item-math">Calculus</div>
                                        <div className="i-title-item-math">Linear Algebra</div>
                                        <div className="i-title-item-math">Topology</div>
                                        <div className="i-title-item-math">Geometry</div>
                                        <div className="i-title-item-math">Statistics</div>
                                        <div className="i-title-item-math">Applied Math</div>
                                        <div className="i-title-item-math">Regression</div>
                                        <div className="i-title-item-math">Analysis</div>
                                        <div className="i-title-item-math">Logic</div>
                                        <div className="i-title-item-math">Optimization</div>
                                        <div className="i-title-item-math">Calculus</div>
                                        <div className="i-title-item-math">Linear Algebra</div>
                                        <div className="i-title-item-math">Statistics</div>
                                    </div>
                                </div>
                            </div>
                            <p>
                            Mathematics serves as the cornerstone of my engineering journey. 
                            By integrating advanced mathematical techniques with practical applications, 
                            I tackle complex challenges in computational mechanics, robotics, and artificial intelligence. 

                            </p>
                </div>
            </div>
            <div className='mathSkillRight'>
                <div className='projectSkillDescription'>
                                <h3>MINI PROJECTS</h3>
                                <div className='skillsWrapperProject'>
                                    <div className="i-title-project">
                                        <div className="i-title-wrapper-project">
                                            <div className="i-title-item-project">3D CLASSIFICATION</div>
                                            <div className="i-title-item-project">TRANSFER LEARNING</div>
                                            <div className="i-title-item-project">TRAINING MNIST</div>
                                            <div className="i-title-item-project">TESTING MNIST</div>
                                            <div className="i-title-item-project">B-SPLINE INTERPOLATOR</div>
                                            <div className="i-title-item-project">BEAM CONTROLLER</div>
                                            <div className="i-title-item-project">CASICAD</div>
                                            <div className="i-title-item-project">IMAGE PROCESSING</div>
                                            <div className="i-title-item-project">DIABETES DETECTION</div>
                                            <div className="i-title-item-project">3D CLASSIFICATION</div>
                                            <div className="i-title-item-project">TRANSFER LEARNING</div>
                                            <div className="i-title-item-project">IMAGE PROCESSING</div>
                                            <div className="i-title-item-project">TRAINING MNIST</div>
                                        </div>
                                    </div>
                                </div>
                                <p>
                                To know more about my projects, check my GitHub!
                                </p>
                                <button className="toGithubProjectSkills">
                                <a href='https://github.com/behzadtabari' target="_blank">
                                    <AiFillGithub className="goToGithubIconSkills" /> Go To GitHub
                                </a>
                                </button>
                    </div>
            </div>
        </section>
    );
}

export default MathSkill;
